/**
 * Static defaults for adhoc modes (adhoc / self-schedule-adhoc).
 * No API is called — the form starts blank and the user fills everything.
 *
 * `location` is intentionally '' here; DetailsForm's useEffect fills it
 * once `useLocationFieldConfig` resolves the account's first available option.
 */
import type { ScheduleInterviewPayload } from '../config/types';

export const ADHOC_PAYLOAD_DEFAULTS: ScheduleInterviewPayload = {
  details: {
    interviewName: '',
    interview_type: 'one_on_one',
    participant_ids: '',
    participant_default_options: [],
    duration: 30,
    location: '',
    host_id: '',
    ats_office_id: '',
    book_meeting_room: false,
    // Single-select field — keep as a string. FormBuilder's Zod schema for a
    // single-select is `z.string()`; an empty array trips a type-mismatch
    // (`Expected string, received array`) when validation runs.
    meeting_room_ids: '',
    calendar_info: null,
    calendar_info_picker: '',
    dateTime: '',
    startDate: null,
    startTime: '',
    endTime: '',
    isDateTimeEditing: 'view',
    isCalendarEditing: 'view',
    findTime: '',
    calendar_visibility: false,
    candidatePhone: '',
    candidate_phone: undefined,
    isCandidatePhoneEditing: 'edit',
    enable_note_taker: false,
    // Single-select → empty string, not null. FormBuilder's Zod schema is
    // `z.string()`; a null trips a type-mismatch ("Expected undefined,
    // received null") instead of the required message. Same rule as
    // `host_id` / `meeting_room_ids` above.
    ext_interview_template_id: '',
  },
  communication: {},
  scorecard: {},
};
